import React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import FormHelperText from '@mui/joy/FormHelperText';
import Input from '@mui/joy/Input';
import Typography from '@mui/joy/Typography';
import LinkIcon from '@mui/icons-material/Link';

import { themeColors, shadows } from '../../styles/theme';

const sanitizeUrlName = (value) => {
  return value.toLowerCase().replace(/[^a-z0-9-]/g, '');
};

export default function UrlNameInput({
  value,
  onChange,
  label = 'URL Name',
  placeholder = 'my-url-name',
  baseUrl = '',
  required = false,
  error = '',
  helperText = ''
}) {
  const handleChange = (e) => {
    const sanitized = sanitizeUrlName(e.target.value);
    onChange(sanitized);
  };

  const previewUrl = baseUrl && value ? `${baseUrl}${value}/` : null;

  return (
    <FormControl required={required} error={!!error}>
      <FormLabel sx={{ fontWeight: 600, mb: 1, color: themeColors.neutral[800] }}>
        {label}
        {required && (
          <Typography component="span" sx={{ color: themeColors.danger, ml: 0.5 }}>
            *
          </Typography>
        )}
      </FormLabel>
      <Input
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        startDecorator={<LinkIcon sx={{ color: themeColors.neutral[500] }} />}
        error={!!error}
        sx={{
          border: 'none',
          boxShadow: error ? `0 0 0 2px ${themeColors.danger}30` : shadows.sm,
          borderRadius: 2,
          backgroundColor: 'white',
          '--Input-focusedThickness': '0px',
          '&:focus-within': {
            boxShadow: error ? `0 0 0 2px ${themeColors.danger}50` : shadows.focus,
          },
          transition: 'all 0.2s ease',
          fontSize: '1rem',
          py: 1.5,
        }}
      />
      {error && (
        <FormHelperText sx={{ color: themeColors.danger, fontSize: '0.875rem', mt: 0.75 }}>
          {error}
        </FormHelperText>
      )}
      {helperText && !error && (
        <FormHelperText sx={{ color: themeColors.neutral[600], fontSize: '0.875rem', mt: 0.75 }}>
          {helperText}
        </FormHelperText>
      )}
      {previewUrl && !error && !helperText && (
        <FormHelperText sx={{ color: themeColors.neutral[600], fontFamily: 'monospace', fontSize: '0.875rem', mt: 0.75 }}>
          🔗 {previewUrl}
        </FormHelperText>
      )}
    </FormControl>
  );
}